module.exports = __webpack_public_path__ + "img/kanban.fa7080f5.png";